export function nextAgentReconnectDelay(attempt: number): number {
  const normalizedAttempt = Number.isFinite(attempt) && attempt > 0 ? Math.floor(attempt) : 1;
  return Math.min(1000 * normalizedAttempt, 10_000);
}
